module.exports = __webpack_public_path__ + "static/assets/a2314e2ba88188350191e52e20f065f9.png";